import React, { useEffect, useState } from 'react';
import { Button, Card, Form, message, Modal, Space, Table } from 'antd';
import axios from 'axios';
import copy from 'copy-to-clipboard';
import BaseView from '../../components/BaseView';
import { Input } from 'antd';
import { Radio } from 'antd';

const name = 'paneland';

function generateUuid() {
  var temp_url = URL.createObjectURL(new Blob());
  var uuid = temp_url.toString();
  URL.revokeObjectURL(temp_url);
  return uuid.substr(uuid.lastIndexOf('/') + 1);
}
function Paneland() {
  const [link, setLink] = useState([]);
  const [uuid, setUuid] = useState('');
  const [formValues, setFormValues] = useState();
  const [form] = Form.useForm();

  useEffect(() => {
    try {
      const json = JSON.parse(localStorage.getItem(`${name}_url_history`));
      const uuid = JSON.parse(localStorage.getItem(`${name}_uuid`));
      setLink(json || []);
      setUuid(uuid || '');
    } catch (e) {
      setLink([]);
    }

    try {
      const json = JSON.parse(localStorage.getItem(`${name}_form`));
      if (!form) return;
      if (json) {
        form.setFieldsValue(json);
        setFormValues(json);
      }
    } catch {}
  }, [form, setFormValues]);

  const handleLink = (e) => {
    axios
      .get(`${name}/getLink`, { params: { ...e } })
      .then((res) => {
        const _ = generateUuid();
        setUuid(_);
        localStorage.setItem(`${name}_uuid`, _);
        setLink(res);
        if (res && res.length > 0) {
          localStorage.setItem(`${name}_url_history`, JSON.stringify(res));
        }
      })
      .catch((e) => {
        console.log(e);
        setLink([]);
      });
  };
  return (
    <BaseView name={name}>
      <Card
        title='操作'
        extra={
          <Space>
            <Button
              onClick={() => {
                window.open('/#/collection');
              }}
            >
              统计
            </Button>
            <Button
              onClick={() => {
                axios.get(`${name}/getIp`).then((res) => {
                  message.success(res);
                });
              }}
            >
              检测IP
            </Button>
            <Form
              onFinish={(e) => {
                setLink(null);
                handleLink(e);
              }}
              style={{ height: '32px' }}
            >
              <Space>
                <Form.Item>
                  <Button
                    htmlType='submit'
                    type='primary'
                    loading={link === null}
                  >
                    获取问卷
                  </Button>
                </Form.Item>
              </Space>
            </Form>
          </Space>
        }
      >
        <Form
          form={form}
          onValuesChange={(_, e) => {
            localStorage.setItem(`${name}_form`, JSON.stringify(e));
            setFormValues(e);
          }}
        >
          <Form.Item label='年龄' name='age'>
            <Input type='number' />
          </Form.Item>
          <Form.Item label='性别' name='gender'>
            <Radio.Group
              options={[
                { label: '男', value: '58' },
                { label: '女', value: '59' },
              ]}
            />
          </Form.Item>
          <Form.Item label='邮编' name='zipCode'>
            <Input />
          </Form.Item>
        </Form>
        <Table
          dataSource={link}
          rowKey={(record) => record.project_id}
          columns={[
            {
              title: 'ID',
              dataIndex: 'project_id',
              sorter: {
                compare: (a, b) => parseFloat(a.ID) - parseFloat(b.ID),
                multiple: 0,
              },
            },
            {
              title: '名称',
              dataIndex: 'name',
            },
            {
              title: 'IR',
              dataIndex: 'ir',
              sorter: {
                compare: (a, b) => parseFloat(a.ss) - parseFloat(b.ss),
                multiple: 3,
              },
            },
            {
              title: '要求时间',
              dataIndex: 'loi',
              sorter: {
                compare: (a, b) => parseFloat(a.loi) - parseFloat(b.loi),
                multiple: 2,
              },
            },
            {
              title: '地区/国家',
              dataIndex: 'country',
              sorter: {
                compare: (a, b) => a.country.localeCompare(b.country, 'zh-CN'),
                multiple: 5,
              },
            },
            {
              title: '金额',
              dataIndex: 'cpi',
              sorter: {
                compare: (a, b) => parseFloat(a.cpi) - parseFloat(b.cpi),
                multiple: 1,
              },
            },
            {
              title: '创建时间',
              dataIndex: 'itime',
              sorter: {
                compare: (a, b) =>
                  new Date(b.itime).valueOf() - new Date(a.itime).valueOf(),
                multiple: 6,
              },
            },
            {
              title: '操作',
              render: (value, record) => (
                <Space>
                  <Button
                    type='primary'
                    onClick={() => {
                      window.open(`/api/pe?surveyId=${record.country}`);
                    }}
                  >
                    配额
                  </Button>
                  <Button
                    type='primary'
                    onClick={() => {
                      const cancel = message.loading('正在打开问卷...');
                      axios
                        .post(`${name}/enter`, {
                          age: formValues.age ? Number(formValues.age) : null,
                          sex: formValues.gender
                            ? formValues.gender === '58'
                              ? 58
                              : 59
                            : null,
                          post_code: formValues.zipCode,
                          survey_name: record.project_id,
                          uuid,
                        })
                        .finally((e) => {
                          const url = new URL(record.entry_link);
                          url.searchParams.set('Age', formValues.age || '');
                          url.searchParams.set(
                            'zipCode',
                            formValues.zipCode || ''
                          );
                          url.searchParams.set(
                            'GENDER',
                            formValues.gender || ''
                          );
                          message.destroy();
                          window.open(url.toString());
                        });
                    }}
                  >
                    打开
                  </Button>
                  <Button
                    onClick={() => {
                      const url = new URL(record.entry_link);
                      url.searchParams.set('Age', formValues.age || '');
                      url.searchParams.set('zipCode', formValues.zipCode || '');
                      url.searchParams.set('GENDER', formValues.gender || '');
                      copy(url.toString());
                      message.success('复制成功');
                    }}
                  >
                    复制
                  </Button>
                </Space>
              ),
            },
          ]}
        />
      </Card>
    </BaseView>
  );
}
export default Paneland;
